import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Menu from './components/Menu';
import Grid from './components/Grid';
import Cursor from './components/Cursor';
import Filter from './components/Filter';
import Coral from './components/CoralTest';
import CookieBar from './components/Cookiebar';
import { preloadImages } from './utils';
import 'colcade';

class Alfred {
	constructor() {
		Promise.all([Alfred.domReady()]).then(() => this.init());
		Menu.init();
		Grid.init();
		Filter.init();
		CookieBar.init();
		Coral.init();
	}

	init() {
		preloadImages('.grid__item-img, .bigimg').then(() => {
			document.body.classList.remove('loading');

			const grid = new Grid(document.querySelector('.grid'));
			const cursor = new Cursor(document.querySelector('.c-cursor'));

			document.dispatchEvent(new Event('bless'));
		});
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Alfred();
